<template>
  <div class="button-register" @click="openModalSync(ModalName.SIGN_UP)">
    <button-base type="green" size="xs">
      {{ getContent(layoutData, defaultLocaleLayoutData, 'header.registerButton') }}
    </button-base>

    <atomic-promo-badge v-if="label" :label="label" :icon="icon" />
  </div>
</template>

<script setup lang="ts">
  import { ModalName } from '@skeleton/consts/modals';

  const { openModalSync } = useModalStore();
  const { layoutData, defaultLocaleLayoutData } = useGlobalStore();
  const { getContent } = useProjectMethods();

  const icon = computed(() => getContent(layoutData, defaultLocaleLayoutData, 'header.promoBadge.icon'));

  const label = computed(() => getContent(layoutData, defaultLocaleLayoutData, 'header.promoBadge.label'));
</script>

<style src="~/assets/styles/components/button/register.scss" lang="scss" />
